import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import iconFile from "../../images/icon-file.svg"
import { fileView } from "../../../../../../services/plans"

const File = ({ file, store }) => {
  const openFile = (e, key) => {
    e.preventDefault()

    fileView(store.user.token, key)
  }
  return (
    <a
      className="info-card_file"
      onClick={e => {
        openFile(e, file.key)
      }}
      href="/#"
    >
      <img src={iconFile} alt={file.name_file} title={file.name_file} />
    </a>
  )
}

File.propTypes = {
  file: propTypes.shape({
    name_file: propTypes.string,
    url: propTypes.string,
    key: propTypes.string
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  store: {
    user: AuthenticationReducer.user
  }
})

export default connect(mapStateToProps)(File)
